import React from "react";
import about_us_3 from "../../../Assets/Images/about/about_us_3.png";
import AboutHeadings from "./AboutHeadings";

const impactPoints = [
  "Our goal is to create 1 Crore+ green advocates in India by 2030.",
  "Create Solar Energy hubs across India.",
  "Say no to Plastics and make plastic-free Homes.",
  "Skill Development of 10 lakhs rural youths across India by 2030.",
  "Develop the Skills of Youths in sports and give them a pathway for a career.",
  "STEM Education and Career for females in Rural schools PAN India.",
  "Good Health and well-being of rural communities.",
  "Develop Women Entrepreneurs in Rural India.",
  // "Create Drone Didi’s in Rural India and generate livelihood.",
];

const ImpactStatus = () => {
  return (
    <div className="flex flex-col lg:flex-row items-center lg:items-start px-4 md:px-10 lg:px-12 gap-8 lg:gap-10 bg-white w-full sm:py-10">
      {/* Left: Image */}
      <div
        className="w-full md:w-1/2 h-full items-center  flex justify-center pl-4"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <div className="relative overflow-hidden w-full  my-auto items-center justify-center transform transition-transform duration-200 hover:scale-102 shadow-lg">
          <img
            src={about_us_3}
            alt="impact_img"
            className="w-full h-auto lg:max-h-[33rem]"
          />
        </div>
      </div>

      {/* Right: Text Content */}
      <div className="w-full md:w-1/2 my-auto">
        {/* <AboutHeadings title={"Impact and Current Status"} textAlign="left" /> */}
        <AboutHeadings title={"Our Vision"} textAlign="left" />

        <ul className="mt-4 space-y-3 text-gray-700 text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed list-inside">
          {impactPoints.map((point, idx) => (
            <li
              key={idx}
              className="before:content-['•'] before:text-orange-400 before:mr-2"
              data-aos={idx % 2 === 0 ? "fade-right" : "fade-left"}
              data-aos-duration="1000"
              data-aos-delay={idx * 150} // staggered effect
            >
              {point}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ImpactStatus;
